import MeetUsWrapper from "Components/MeetUsWrapper";
import React from "react";
import styles from "./style.module.scss";
import BgEarnAndEngage from "Utils/Assets/Images/BgEarnAndEngage.png";
import WhatsApp from "Utils/Assets/Images/WhatsApp.png";
import upwork from "Utils/Assets/Images/upwork.png";
import meetusvrlogo from "Utils/Assets/Images/meetusvrlogo.png";

import square from "Utils/Assets/Images/square.png";
import VR from "Utils/Assets/Images/VR.png";
import money from "Utils/Assets/Images/money.png";

const comparisonRows = [
    {
        meetusVR: "Monetized Social Engagement",
        whatsApp: "Lacks monetization; users engage without financial rewards.",
        upwork: "Focuses on formal client with freelancer relationships.",
    },
    {
        meetusVR: "Blockchain-Powered Economy",
        whatsApp: "Limited to messaging; lacks integrated economic incentives.",
        upwork: "Freelancers face high competition and service fees.",
    },
    {
        meetusVR: "Immersive Virtual Experiences",
        whatsApp:
            "Offers basic messaging and calling features without immersive experiences.",
        upwork: "Platform for job postings but lacks virtual interaction or community-building features.",
    },
    {
        meetusVR: "Earning Opportunities",
        whatsApp: "No earning mechanisms for regular users.",
        upwork: "Freelancers earn per project but face high competition and fees,",
    },
];

const meetusvrFeatures = [
    {
        text: "Chat, interact, and earn MVR Coins within an immersive metaverse.",
        variant: "info",
    },
    {
        text: "Transparent, secure transactions with real financial rewards.",
        variant: "infoBg",
    },
    {
        text: "Hosts events, networking, and commerce in a rich virtual environment.",
        variant: "info",
    },
    {
        text: "Users earn by engaging in various activities within the platform.",
        variant: "infoBg",
    },
];

const bottomCards = [
    {
        icon: square,
        iconClass: "square",
        title: "Metaverse Events",
        description: "Fully immersive networking & social interaction.",
        animation: "fade-left",
    },
    {
        icon: VR,
        iconClass: "VR",
        title: "VR Shopping",
        description: "Virtual stores with real-world payments.",
        animation: "fade-up",
    },
    {
        icon: money,
        iconClass: "money",
        title: "Play-to-Earn Economy",
        description: "Users earn while engaging in digital activities.",
        animation: "fade-right",
    },
];

const EarnAndEngageSection = () => {
    return (
        <div className={styles.earnAndEngage}>
            <img
                src={BgEarnAndEngage}
                alt="BgEarnAndEngage"
                className={styles.earnAndEngageBg}
            />

            <MeetUsWrapper>
                <div className={styles.earnAndEngageContent}>
                    <div
                        data-aos="fade-down"
                        data-aos-duration="800"
                        data-aos-once="false"
                    >
                        <h1 className={styles.earnAndEngageTitle}>
                            Unlike Traditional Platforms,
                            <br /> MeetUsVR is Designed For
                        </h1>
                    </div>

                    <div className={styles.cards}>
                        <div
                            className={styles.cardLarge}
                            data-aos="fade-up"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            {/* Desktop: 3-column comparison grid */}
                            <div className={styles.desktopOnly}>
                                <div className={styles.grid}>
                                    <div></div>
                                    <div>
                                        <img
                                            src={WhatsApp}
                                            alt="WhatsApp"
                                            className={styles.whatsApp}
                                        />
                                    </div>
                                    <div>
                                        <img
                                            src={upwork}
                                            alt="Upwork"
                                            className={styles.upwork}
                                        />
                                    </div>
                                </div>
                                {comparisonRows.map((row, index) => (
                                    <div className={styles.gridBottom} key={index}>
                                        <div>
                                            <p className={styles.gridBottomText}>
                                                {row.meetusVR}
                                            </p>
                                        </div>
                                        <div>
                                            <p className={styles.gridBottomText}>
                                                {row.whatsApp}
                                            </p>
                                        </div>
                                        <div>
                                            <p className={styles.gridBottomText}>
                                                {row.upwork}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Mobile: one card per platform, stacked */}
                            <div className={styles.mobileOnly}>
                                {[
                                    {
                                        logo: WhatsApp,
                                        alt: "WhatsApp",
                                        logoClass: styles.whatsApp,
                                        key: "whatsApp",
                                    },
                                    {
                                        logo: upwork,
                                        alt: "Upwork",
                                        logoClass: styles.upwork,
                                        key: "upwork",
                                    },
                                ].map((platform) => (
                                    <div
                                        className={styles.mobilePlatform}
                                        key={platform.key}
                                    >
                                        <div className={styles.mobilePlatformHeader}>
                                            <img
                                                src={platform.logo}
                                                alt={platform.alt}
                                                className={platform.logoClass}
                                            />
                                        </div>
                                        {comparisonRows.map((row, i) => (
                                            <div
                                                className={styles.mobilePlatformRow}
                                                key={i}
                                            >
                                                <p className={styles.mobilePlatformCategory}>
                                                    {row.meetusVR}
                                                </p>
                                                <p className={styles.gridBottomText}>
                                                    {row[platform.key]}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div
                            className={styles.cardSmall}
                            data-aos="fade-left"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div className={styles.image}>
                                <img
                                    src={meetusvrlogo}
                                    className={styles.meetusvrlogo}
                                    alt="meetusvr logo"
                                />
                            </div>
                            <div className={styles.flex}>
                                {meetusvrFeatures.map((feature, index) => (
                                    <div
                                        className={styles[feature.variant]}
                                        key={index}
                                    >
                                        <p className={styles.infoCategory}>
                                            {comparisonRows[index].meetusVR}
                                        </p>
                                        <p className={styles.infoText}>
                                            {feature.text}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className={styles.cardsBottom}>
                        {bottomCards.map((card, index) => (
                            <div
                                className={styles.cardBottom}
                                data-aos={card.animation}
                                data-aos-duration="800"
                                data-aos-once="false"
                                key={index}
                            >
                                <img
                                    src={card.icon}
                                    alt={card.title}
                                    className={styles[card.iconClass]}
                                />
                                <div>
                                    <p className={styles.cardBottomText}>
                                        {card.title}
                                    </p>
                                    <p className={styles.cardBottomDes}>
                                        {card.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default EarnAndEngageSection;
